// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file forms/v1/field.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { BooleanOperator, Operator } from '../../bundles/v1/rules_pb'
import { file_bundles_v1_rules } from '../../bundles/v1/rules_pb'
import type { Value } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_struct } from '@bufbuild/protobuf/wkt'
import type { JsonObject, Message } from '@bufbuild/protobuf'

/**
 * Describes the file forms/v1/field.proto.
 */
export const file_forms_v1_field: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChRmb3Jtcy92MS9maWVsZC5wcm90bxIIZm9ybXMudjEiFwoGQ2hvaWNlEg0KBXZhbHVlGAEgASgJInoKFUNob2ljZUZpZWxkUHJvcGVydGllcxIhCgdjaG9pY2VzGAEgAygLMhAuZm9ybXMudjEuQ2hvaWNlEikKC2Nob2ljZV90eXBlGAIgASgOMhQuZm9ybXMudjEuQ2hvaWNlVHlwZRITCgthbGxvd19vdGhlchgDIAEoCCIoChNUZXh0RmllbGRQcm9wZXJ0aWVzEhEKCXBhcmFncmFwaBgBIAEoCCIpChRJbWFnZUJsb2NrUHJvcGVydGllcxIRCglpbWFnZV91cmwYASABKAkiPgoUTGVnYWxGaWVsZFByb3BlcnRpZXMSEgoKdGVybXNfbGluaxgBIAEoCRISCgpkaXNjbGFpbWVyGAIgASgJIukBCg9GaWVsZFByb3BlcnRpZXMSMQoGY2hvaWNlGAEgASgLMh8uZm9ybXMudjEuQ2hvaWNlRmllbGRQcm9wZXJ0aWVzSAASMwoKdGV4dF9maWVsZBgCIAEoCzIdLmZvcm1zLnYxLlRleHRGaWVsZFByb3BlcnRpZXNIABIvCgVpbWFnZRgDIAEoCzIeLmZvcm1zLnYxLkltYWdlQmxvY2tQcm9wZXJ0aWVzSAASLwoFbGVnYWwYBCABKAsyHi5mb3Jtcy52MS5MZWdhbEZpZWxkUHJvcGVydGllc0gAQgwKCnByb3BlcnRpZXMibAoKTW9kZWxGaWVsZBIRCgltb2RlbF9rZXkYASABKAkSFQoNbW9kZWxfdmVyc2lvbhgCIAEoCRIXCg9tb2RlbF9maWVsZF9rZXkYAyABKAkSGwoTbW9kZWxfZmllbGRfdmVyc2lvbhgEIAEoCSJfCg5WYWxpZGF0aW9uUnVsZRImCghvcGVyYXRvchgBIAEoDjIULmJ1bmRsZXMudjEuT3BlcmF0b3ISJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWUiewoKVmFsaWRhdGlvbhItCghvcGVyYXRvchgBIAEoDjIbLmJ1bmRsZXMudjEuQm9vbGVhbk9wZXJhdG9yEhUKDWVycm9yX21lc3NhZ2UYAiABKAkSJwoFcnVsZXMYAyADKAsyGC5mb3Jtcy52MS5WYWxpZGF0aW9uUnVsZSIyCgZDb25maWcSKAoKdmFsaWRhdGlvbhgBIAEoCzIULmZvcm1zLnYxLlZhbGlkYXRpb24i5wIKBUZpZWxkEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSDQoFdGl0bGUYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSDgoGYWN0aXZlGAUgASgIEicKCmZpZWxkX3R5cGUYBiABKA4yEy5mb3Jtcy52MS5GaWVsZFR5cGUSEAoIcmVxdWlyZWQYByABKAgSLQoKcHJvcGVydGllcxgIIAEoCzIZLmZvcm1zLnYxLkZpZWxkUHJvcGVydGllcxIRCglpbW11dGFibGUYCSABKAgSDgoGc3RhdGljGAogASgIEi4KDWRlZmF1bHRfdmFsdWUYCyABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0EjEKE21vZGVsX2ZpZWxkX2JpbmRpbmcYDCABKAsyFC5mb3Jtcy52MS5Nb2RlbEZpZWxkEiAKBmNvbmZpZxgNIAEoCzIQLmZvcm1zLnYxLkNvbmZpZyrWAgoJRmllbGRUeXBlEhoKFkZJRUxEX1RZUEVfVU5TUEVDSUZJRUQQABITCg9GSUVMRF9UWVBFX1RFWFQQARIWChJGSUVMRF9UWVBFX0FERFJFU1MQAhIVChFGSUVMRF9UWVBFX0NIT0lDRRADEhQKEEZJRUxEX1RZUEVfRU1BSUwQBBIUChBGSUVMRF9UWVBFX1BIT05FEAUSFAoQRklFTERfVFlQRV9MRUdBTBAGEhMKD0ZJRUxEX1RZUEVfREFURRAHEhkKFUZJRUxEX1RZUEVfQkxPQ0tfVEVYVBAIEhMKD0ZJRUxEX1RZUEVfTkFNRRAJEhoKFkZJRUxEX1RZUEVfQkxPQ0tfSU1BR0UQChITCg9GSUVMRF9UWVBFX1BPTEwQCxIaChZGSUVMRF9UWVBFX0ZJTEVfVVBMT0FEEAwSFQoRRklFTERfVFlQRV9OVU1CRVIQDSp0CgpDaG9pY2VUeXBlEhsKF0NIT0lDRV9UWVBFX1VOU1BFQ0lGSUVEEAASFQoRQ0hPSUNFX1RZUEVfUkFESU8QARIYChRDSE9JQ0VfVFlQRV9EUk9QRE9XThACEhgKFENIT0lDRV9UWVBFX0NIRUNLQk9YEANiBnByb3RvMw',
    [file_bundles_v1_rules, file_google_protobuf_struct]
  )

/**
 * @generated from message forms.v1.Choice
 */
export type Choice = Message<'forms.v1.Choice'> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string
}

/**
 * Describes the message forms.v1.Choice.
 * Use `create(ChoiceSchema)` to create a new message.
 */
export const ChoiceSchema: GenMessage<Choice> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 0)

/**
 * @generated from message forms.v1.ChoiceFieldProperties
 */
export type ChoiceFieldProperties = Message<'forms.v1.ChoiceFieldProperties'> & {
  /**
   * @generated from field: repeated forms.v1.Choice choices = 1;
   */
  choices: Choice[]

  /**
   * @generated from field: forms.v1.ChoiceType choice_type = 2;
   */
  choiceType: ChoiceType

  /**
   * @generated from field: bool allow_other = 3;
   */
  allowOther: boolean
}

/**
 * Describes the message forms.v1.ChoiceFieldProperties.
 * Use `create(ChoiceFieldPropertiesSchema)` to create a new message.
 */
export const ChoiceFieldPropertiesSchema: GenMessage<ChoiceFieldProperties> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 1)

/**
 * @generated from message forms.v1.TextFieldProperties
 */
export type TextFieldProperties = Message<'forms.v1.TextFieldProperties'> & {
  /**
   * @generated from field: bool paragraph = 1;
   */
  paragraph: boolean
}

/**
 * Describes the message forms.v1.TextFieldProperties.
 * Use `create(TextFieldPropertiesSchema)` to create a new message.
 */
export const TextFieldPropertiesSchema: GenMessage<TextFieldProperties> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 2)

/**
 * @generated from message forms.v1.ImageBlockProperties
 */
export type ImageBlockProperties = Message<'forms.v1.ImageBlockProperties'> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string
}

/**
 * Describes the message forms.v1.ImageBlockProperties.
 * Use `create(ImageBlockPropertiesSchema)` to create a new message.
 */
export const ImageBlockPropertiesSchema: GenMessage<ImageBlockProperties> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 3)

/**
 * @generated from message forms.v1.LegalFieldProperties
 */
export type LegalFieldProperties = Message<'forms.v1.LegalFieldProperties'> & {
  /**
   * @generated from field: string terms_link = 1;
   */
  termsLink: string

  /**
   * @generated from field: string disclaimer = 2;
   */
  disclaimer: string
}

/**
 * Describes the message forms.v1.LegalFieldProperties.
 * Use `create(LegalFieldPropertiesSchema)` to create a new message.
 */
export const LegalFieldPropertiesSchema: GenMessage<LegalFieldProperties> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 4)

/**
 * @generated from message forms.v1.FieldProperties
 */
export type FieldProperties = Message<'forms.v1.FieldProperties'> & {
  /**
   * @generated from oneof forms.v1.FieldProperties.properties
   */
  properties:
    | {
        /**
         * @generated from field: forms.v1.ChoiceFieldProperties choice = 1;
         */
        value: ChoiceFieldProperties
        case: 'choice'
      }
    | {
        /**
         * @generated from field: forms.v1.TextFieldProperties text_field = 2;
         */
        value: TextFieldProperties
        case: 'textField'
      }
    | {
        /**
         * @generated from field: forms.v1.ImageBlockProperties image = 3;
         */
        value: ImageBlockProperties
        case: 'image'
      }
    | {
        /**
         * @generated from field: forms.v1.LegalFieldProperties legal = 4;
         */
        value: LegalFieldProperties
        case: 'legal'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message forms.v1.FieldProperties.
 * Use `create(FieldPropertiesSchema)` to create a new message.
 */
export const FieldPropertiesSchema: GenMessage<FieldProperties> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 5)

/**
 * Represents a model.field to which a form
 * field can be bound
 *
 * @generated from message forms.v1.ModelField
 */
export type ModelField = Message<'forms.v1.ModelField'> & {
  /**
   * the model key (e.g. contact)
   *
   * @generated from field: string model_key = 1;
   */
  modelKey: string

  /**
   * optional model version
   *
   * @generated from field: string model_version = 2;
   */
  modelVersion: string

  /**
   * the key for the model field (e.g. first_name)
   *
   * @generated from field: string model_field_key = 3;
   */
  modelFieldKey: string

  /**
   * optional model field version
   *
   * @generated from field: string model_field_version = 4;
   */
  modelFieldVersion: string
}

/**
 * Describes the message forms.v1.ModelField.
 * Use `create(ModelFieldSchema)` to create a new message.
 */
export const ModelFieldSchema: GenMessage<ModelField> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 6)

/**
 * @generated from message forms.v1.ValidationRule
 */
export type ValidationRule = Message<'forms.v1.ValidationRule'> & {
  /**
   * @generated from field: bundles.v1.Operator operator = 1;
   */
  operator: Operator

  /**
   * @generated from field: google.protobuf.Value value = 2;
   */
  value?: Value
}

/**
 * Describes the message forms.v1.ValidationRule.
 * Use `create(ValidationRuleSchema)` to create a new message.
 */
export const ValidationRuleSchema: GenMessage<ValidationRule> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 7)

/**
 * @generated from message forms.v1.Validation
 */
export type Validation = Message<'forms.v1.Validation'> & {
  /**
   * @generated from field: bundles.v1.BooleanOperator operator = 1;
   */
  operator: BooleanOperator

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string

  /**
   * @generated from field: repeated forms.v1.ValidationRule rules = 3;
   */
  rules: ValidationRule[]
}

/**
 * Describes the message forms.v1.Validation.
 * Use `create(ValidationSchema)` to create a new message.
 */
export const ValidationSchema: GenMessage<Validation> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_field, 8)

/**
 * @generated from message forms.v1.Config
 */
export type Config = Message<'forms.v1.Config'> & {
  /**
   * @generated from field: forms.v1.Validation validation = 1;
   */
  validation?: Validation
}

/**
 * Describes the message forms.v1.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema: GenMessage<Config> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 9)

/**
 * @generated from message forms.v1.Field
 */
export type Field = Message<'forms.v1.Field'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string title = 3;
   */
  title: string

  /**
   * @generated from field: string description = 4;
   */
  description: string

  /**
   * @generated from field: bool active = 5;
   */
  active: boolean

  /**
   * @generated from field: forms.v1.FieldType field_type = 6;
   */
  fieldType: FieldType

  /**
   * @generated from field: bool required = 7;
   */
  required: boolean

  /**
   * @generated from field: forms.v1.FieldProperties properties = 8;
   */
  properties?: FieldProperties

  /**
   * whether the field is editable in the editor
   *
   * @generated from field: bool immutable = 9;
   */
  immutable: boolean

  /**
   * whether the field is fillable on a landing page
   *
   * @generated from field: bool static = 10;
   */
  static: boolean

  /**
   * @generated from field: google.protobuf.Struct default_value = 11;
   */
  defaultValue?: JsonObject

  /**
   * the model field bound to this form field
   *
   * @generated from field: forms.v1.ModelField model_field_binding = 12;
   */
  modelFieldBinding?: ModelField

  /**
   * @generated from field: forms.v1.Config config = 13;
   */
  config?: Config
}

/**
 * Describes the message forms.v1.Field.
 * Use `create(FieldSchema)` to create a new message.
 */
export const FieldSchema: GenMessage<Field> = /*@__PURE__*/ messageDesc(file_forms_v1_field, 10)

/**
 * @generated from enum forms.v1.FieldType
 */
export enum FieldType {
  /**
   * @generated from enum value: FIELD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FIELD_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: FIELD_TYPE_ADDRESS = 2;
   */
  ADDRESS = 2,

  /**
   * @generated from enum value: FIELD_TYPE_CHOICE = 3;
   */
  CHOICE = 3,

  /**
   * @generated from enum value: FIELD_TYPE_EMAIL = 4;
   */
  EMAIL = 4,

  /**
   * @generated from enum value: FIELD_TYPE_PHONE = 5;
   */
  PHONE = 5,

  /**
   * @generated from enum value: FIELD_TYPE_LEGAL = 6;
   */
  LEGAL = 6,

  /**
   * @generated from enum value: FIELD_TYPE_DATE = 7;
   */
  DATE = 7,

  /**
   * @generated from enum value: FIELD_TYPE_BLOCK_TEXT = 8;
   */
  BLOCK_TEXT = 8,

  /**
   * @generated from enum value: FIELD_TYPE_NAME = 9;
   */
  NAME = 9,

  /**
   * @generated from enum value: FIELD_TYPE_BLOCK_IMAGE = 10;
   */
  BLOCK_IMAGE = 10,

  /**
   * @generated from enum value: FIELD_TYPE_POLL = 11;
   */
  POLL = 11,

  /**
   * @generated from enum value: FIELD_TYPE_FILE_UPLOAD = 12;
   */
  FILE_UPLOAD = 12,

  /**
   * @generated from enum value: FIELD_TYPE_NUMBER = 13;
   */
  NUMBER = 13
}

/**
 * Describes the enum forms.v1.FieldType.
 */
export const FieldTypeSchema: GenEnum<FieldType> = /*@__PURE__*/ enumDesc(file_forms_v1_field, 0)

/**
 * @generated from enum forms.v1.ChoiceType
 */
export enum ChoiceType {
  /**
   * @generated from enum value: CHOICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHOICE_TYPE_RADIO = 1;
   */
  RADIO = 1,

  /**
   * @generated from enum value: CHOICE_TYPE_DROPDOWN = 2;
   */
  DROPDOWN = 2,

  /**
   * @generated from enum value: CHOICE_TYPE_CHECKBOX = 3;
   */
  CHECKBOX = 3
}

/**
 * Describes the enum forms.v1.ChoiceType.
 */
export const ChoiceTypeSchema: GenEnum<ChoiceType> = /*@__PURE__*/ enumDesc(file_forms_v1_field, 1)
